import React from 'react';
import { BANNER_WIDGET_LAYOUT_TYPE_V2, BannerWidgetDetailV2 } from '../../../../../../../types/widget';
import PreviewGrid from '../../../../../../../components/preview/PreviewGrid';
import Img from '../../../../../../../components/Img/Img';
import notFoundImg from '../../../../../../../static/images/common/not-found-img.png';
import { BannerWidgetGridLayoutStyle } from './style';

export type BannerWidgetGridLayoutDetail = BannerWidgetDetailV2 & {
  layoutType: typeof BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_1X2 | typeof BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_2X2;
};

interface BannerWidgetGridLayoutProps {
  detail: BannerWidgetGridLayoutDetail;
}
const BannerWidgetGridLayout = (props: BannerWidgetGridLayoutProps) => {
  const { detail } = props;

  const count = detail.layoutType === BANNER_WIDGET_LAYOUT_TYPE_V2.GRID_1X2 ? 2 : 4;

  return (
    <BannerWidgetGridLayoutStyle>
      <PreviewGrid col={2} rowGap={15} colGap={15}>
        {detail.widgetItemBanners?.slice(0, count).map((eventSection) => {
          const image = eventSection.mobileImage?.[0];
          return (
            <div key={eventSection.id}>
              <Img clickAble={false} src={image?.url || notFoundImg} />
            </div>
          );
        })}
      </PreviewGrid>
    </BannerWidgetGridLayoutStyle>
  );
};

export default BannerWidgetGridLayout;
